/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespSidebarBlurbs_domesticDeliveryOptions = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbs_domesticDeliveryOptions",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbShipping_domesticDeliveryOptions",
      "args": null
    }
  ],
  "type": "ShipmentQuoteConnection"
};

module.exports = fragment;
